var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 11.948L31.424 53.06L16.16 37.796L21.236 32.72L31.424 42.908L67.424 6.908L72.5 11.948ZM64.544 30.092C65.012 32.144 65.3 34.304 65.3 36.5C65.3 52.412 52.412 65.3 36.5 65.3C20.588 65.3 7.7 52.412 7.7 36.5C7.7 20.588 20.588 7.7 36.5 7.7C42.188 7.7 47.444 9.356 51.908 12.2L57.092 7.016C51.26 2.912 44.168 0.5 36.5 0.5C16.628 0.5 0.5 16.628 0.5 36.5C0.5 56.372 16.628 72.5 36.5 72.5C56.372 72.5 72.5 56.372 72.5 36.5C72.5 32.216 71.708 28.112 70.34 24.296L64.544 30.092Z",
    fill: "#34BD6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.d1c7eefafa6c6a2ebe059b10b305d680.svg";
export { ForwardRef as ReactComponent };